module.exports = require("koa-static");